import { GOVGR_GR_BUTTON_GROUP } from "../../conf/styles/GovGrButtonGroup";

const GovButtonGroup = ({ children }) => {
  return <div className={`${GOVGR_GR_BUTTON_GROUP}`}>{children}</div>;
};

export default GovButtonGroup;
